var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-company-edit-wrapper",
    { attrs: { "no-scroll": "", company: _vm.company } },
    [
      _c(
        "w-row",
        { attrs: { grow: "" } },
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c(
                "w-card",
                [
                  _c("w-card-title", [
                    _vm._v("OfflineID: " + _vm._s(_vm.company.WfOfflineID)),
                  ]),
                  _c(
                    "w-card-content",
                    [
                      _c(
                        "w-row",
                        [
                          _c(
                            "w-col",
                            { attrs: { xs: "12", md: "6" } },
                            [
                              _c("app-label", {
                                attrs: {
                                  label: "Firstname",
                                  value: _vm.address.firstName,
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12", md: "6" } },
                            [
                              _c("app-label", {
                                attrs: {
                                  label: "Lastname",
                                  value: _vm.address.lastName,
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12", md: "6" } },
                            [
                              _c("app-label", {
                                attrs: {
                                  label: "Company name",
                                  value: _vm.address.companyName,
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12", md: "6" } },
                            [
                              _c("app-label", {
                                attrs: {
                                  label: "Vat number",
                                  value: _vm.address.vatNumber,
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("app-label", {
                                attrs: {
                                  label: "Address",
                                  value: _vm.address.address,
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "8", md: "6" } },
                            [
                              _c("app-label", {
                                attrs: {
                                  label: "Place",
                                  value: _vm.address.place,
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "4", md: "6" } },
                            [
                              _c("app-label", {
                                attrs: {
                                  label: "Postal",
                                  value: _vm.address.postal,
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12", md: "6" } },
                            [
                              _c("app-label", {
                                attrs: { label: "Tel", value: _vm.address.tel },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12", md: "6" } },
                            [
                              _c("app-label", {
                                attrs: {
                                  label: "Email",
                                  value: _vm.address.email,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }